/**
 * date 时间组件
 */
import { DatePicker, DatePickerProps } from 'antd';
import { isDateComponent } from '../../../libs';
import { FieldType, IConfigField, IValue } from '../../../model';

const { RangePicker } = DatePicker;

interface IPropsDate<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}
export const DynamicDate = <T,>(props: IPropsDate<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;

  if (isFilterModeView) {
    const filterOptExtension = isDateComponent(fieldConfig.filterOptExtension);
    if (!filterOptExtension) {
      return null;
    }

    if (fieldConfig.filter_type === FieldType.date_range) {
      const onChangeRange = (dates: any) => {
        props.onChanged(fieldConfig.key, dates);
      };
      const value = selectedValue.value || [];
      return (
        <RangePicker
          value={value}
          onChange={onChangeRange}
          className={props.className}
          autoFocus={filterOptExtension.autoFocus}
          allowClear={filterOptExtension.allowClear}
          bordered={filterOptExtension.bordered}
          disabled={filterOptExtension.disabled}
          disabledDate={filterOptExtension.disabledDate}
          dropdownClassName={filterOptExtension.dropdownClassName}
          nextIcon={filterOptExtension.nextIcon}
          prevIcon={filterOptExtension.prevIcon}
          open={filterOptExtension.open}
          panelRender={filterOptExtension.panelRender}
          popupStyle={filterOptExtension.popupStyle}
          size={filterOptExtension.size}
          style={filterOptExtension.style}
          suffixIcon={filterOptExtension.suffixIcon}
          superNextIcon={filterOptExtension.superNextIcon}
          superPrevIcon={filterOptExtension.superPrevIcon}
          onOpenChange={filterOptExtension.onOpenChange}
          onPanelChange={filterOptExtension.onPanelChange}
        />
      );
    }

    if (fieldConfig.filter_type === FieldType.date) {
      const onChangeDate = (value: DatePickerProps['value']) => {
        props.onChanged(fieldConfig.key, value);
      };
      const value = selectedValue.value || '';
      return (
        <DatePicker
          defaultValue={value}
          value={value}
          onChange={onChangeDate}
          className={props.className}
          allowClear={filterOptExtension.allowClear}
          autoFocus={filterOptExtension.autoFocus}
          bordered={filterOptExtension.bordered}
          disabled={filterOptExtension.disabled as boolean}
          disabledDate={filterOptExtension.disabledDate}
          dropdownClassName={filterOptExtension.dropdownClassName}
          nextIcon={filterOptExtension.nextIcon}
          prevIcon={filterOptExtension.prevIcon}
          open={filterOptExtension.open}
          panelRender={filterOptExtension.panelRender}
          popupStyle={filterOptExtension.popupStyle}
          size={filterOptExtension.size}
          style={filterOptExtension.style}
          suffixIcon={filterOptExtension.suffixIcon}
          superNextIcon={filterOptExtension.superNextIcon}
          superPrevIcon={filterOptExtension.superPrevIcon}
          onOpenChange={filterOptExtension.onOpenChange}
          onPanelChange={filterOptExtension.onPanelChange}
        />
      );
    }
  }

  return <span className={props.className}>{selectedValue.value}</span>;
};
